export const kpiCategoryHoverPlugin = {
  id: "kpiCategoryHover",
  beforeDatasetsDraw(chart, _args, options = {}) {
    const activeElement = chart.getActiveElements()[0];
    const xScale = chart.scales?.x;
    const { chartArea, ctx } = chart;

    if (
      !activeElement ||
      !xScale ||
      !chartArea ||
      !Number.isInteger(activeElement.index)
    ) {
      return;
    }

    const categoryIndex = activeElement.index;
    const tickCount = xScale.ticks?.length || 0;
    if (categoryIndex < 0 || categoryIndex >= tickCount) return;

    const center = xScale.getPixelForTick(categoryIndex);
    const left =
      categoryIndex === 0
        ? chartArea.left
        : (xScale.getPixelForTick(categoryIndex - 1) + center) / 2;
    const right =
      categoryIndex === tickCount - 1
        ? chartArea.right
        : (center + xScale.getPixelForTick(categoryIndex + 1)) / 2;

    ctx.save();
    ctx.fillStyle = options.backgroundColor || "rgba(47, 111, 184, 0.08)";
    ctx.fillRect(left, chartArea.top, right - left, chartArea.bottom - chartArea.top);
    ctx.restore();
  },
};
